export default "__VITE_ASSET__bpGl9PSn__"